// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__pLVNx","spin":"spinner_spin__0aHVT"};